export const ARRET_TELESUIVI = 1;
export const MISE_EN_SERVICE_TELESUIVI = 2;
export const REGLAGE_PARAMETRE = 3;
export const DEFAUT_PRODUCTION = 4;
export const PERTE_PRODUCTION = 5;
export const ARRET_PRODUCTION_ONDULEUR = 6;
export const PERTE_PRODUCTION_ONDULEUR = 7;
export const PROBLEME_COM_OU_PROD = 8;
export const PROBLEME_COM = 9;
export const DONNEES_MANQUANTES = 10;
export const DONNEES_ERRONNEES = 11;
export const ALARMES_NON_CONCLUANTES = 12;
export const RESEAU_HORS_LIMITES = 13;
export const INTERVENTION_PREVENTIVE = 15;
